<ng-container *transloco="let convert;">
  <app-offer-modals-header
    heading="{{ convert('vehicles.cancelOffer.textViewOffer') }}"
    [tenantName]="tenantName"
    [headingId]="modalId + '-title'"
  ></app-offer-modals-header>
  <div class="modal__content">
    <p class="text-danger fw-bold" [class.d-none]="!errorMessage" aria-atomic="true" aria-live="polite" #error>
      @if (errorMessage) {
        {{ convert('vehicles.cancelOffer.errorMsg') }}
      }
    </p>
    <app-offer-history [vin]="item.vin" [offerHistory]="offerHistory"></app-offer-history>

    <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
      <button
        id="vom_decline_offer_button"
        class="btn btn-primary"
        type="submit"
        (click)="cancel()"
        data-track-elem="button"
        data-track-name="Close"
        data-track-trigger="close"
        >
        {{ convert('common.btnClose') }}
      </button>
    </div>
  </div>
  <app-modal-close (close)="cancel()"></app-modal-close>
</ng-container>
